import { Link } from "react-router-dom"
// import CryptoJS from "crypto-js"

import { Container, FullRow, NormalText, Title } from "../../components"





export function Activated(): JSX.Element {
  
  return (
    <Container style={{ marginTop: "3.5em" }}>
      <FullRow>
        <Title>Welcome!</Title>
      </FullRow>
      <FullRow>
        <NormalText> Your account has been activated, click <Link to='/login'>here</Link>  to log in.</NormalText>
      </FullRow>
      
    </Container>
  )
}
